import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiFilter, FiMoreVertical } from 'react-icons/fi';
import { RFIS } from '../data/mockData';

export const RFIs = () => {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6 h-full flex flex-col">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-100 tracking-tight">RFI Tracker</h1>
          <p className="text-slate-400 text-sm mt-1 font-mono">Manage Requests for Information across all sectors.</p>
        </div>
        <div className="flex gap-3">
          <button className="flex items-center gap-2 bg-slate-800 hover:bg-slate-700 text-slate-300 px-3 py-2 rounded-sm text-sm font-medium transition-colors">
            <SafeIcon icon={FiFilter} /> Filter
          </button>
          <button className="flex items-center gap-2 bg-cyan-600 hover:bg-cyan-500 text-slate-950 px-4 py-2 rounded-sm text-sm font-bold transition-colors">
            <SafeIcon icon={FiPlus} /> New RFI
          </button>
        </div>
      </div>

      <Card className="flex-1 overflow-hidden flex flex-col p-0">
        <div className="overflow-x-auto flex-1">
          <table className="w-full text-left text-sm text-slate-300">
            <thead className="bg-slate-900/80 text-xs uppercase font-mono text-slate-500 border-b border-slate-800">
              <tr>
                <th className="px-6 py-4 font-medium">ID</th>
                <th className="px-6 py-4 font-medium">Subject</th>
                <th className="px-6 py-4 font-medium">Project</th>
                <th className="px-6 py-4 font-medium">Status</th>
                <th className="px-6 py-4 font-medium">Priority</th>
                <th className="px-6 py-4 font-medium">Date Issued</th>
                <th className="px-6 py-4 font-medium text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800/60">
              {RFIS.map((rfi) => (
                <tr key={rfi.id} className="hover:bg-slate-800/40 transition-colors group">
                  <td className="px-6 py-4 font-mono text-cyan-500">{rfi.id}</td>
                  <td className="px-6 py-4 font-medium text-slate-200">{rfi.title}</td>
                  <td className="px-6 py-4 text-slate-400">{rfi.project}</td>
                  <td className="px-6 py-4">
                    <Badge variant={rfi.status === 'Open' ? 'cyan' : rfi.status === 'Resolved' ? 'green' : 'default'}>
                      {rfi.status}
                    </Badge>
                  </td>
                  <td className="px-6 py-4">
                    <Badge variant={rfi.priority === 'Critical' ? 'red' : rfi.priority === 'High' ? 'yellow' : 'default'}>
                      {rfi.priority}
                    </Badge>
                  </td>
                  <td className="px-6 py-4 font-mono text-slate-500">{rfi.date}</td>
                  <td className="px-6 py-4 text-right">
                    <button className="text-slate-500 hover:text-cyan-400 opacity-0 group-hover:opacity-100 transition-all">
                      <SafeIcon icon={FiMoreVertical} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </motion.div>
  );
};